// extracted by mini-css-extract-plugin
export default {"container":"ServiceDashboard_container__Y-n70","purpleText":"ServiceDashboard_purpleText__Efe3h"};